import classNames from 'classnames';
import * as color from 'color';
import * as generaldb from '../../../shared/db/general-db';
import * as tagsdb from '../../../shared/db/tags-db';

import {
  assoc,
  dissoc,
  keys,
  path,
  pathOr,
} from 'ramda';
import React, {CSSProperties as css, useEffect, useMemo, useRef, useState} from 'react';
import { MAP } from 'react-google-maps/lib/constants';
import { DispatchProp, connect, useSelector } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { ReactComponent as NotificationsOnIcon } from '../../../assets/svg/notification_16w.svg';
import { ReactComponent as NotificationsOffIcon } from '../../../assets/svg/notifications_off_cur.svg';
import { ReactComponent as PublicIcon } from '../../../assets/svg/public_cur.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/delete.svg';
import { ALL_DEVICES_TAG, makeAudit, vals } from '../../../shared/helpers';
import {
  IconTypes,
  ItemType,
  UserAuth,
  iFullStoreState,
  iIcon,
  iList,
  iPerson,
  iTag,
} from '../../../shared/interfaces';
import { Actions as GmapActions } from '../../../stores/reducers/gmap-reducers';
import {
  hideAllTags,
  hideSelectedDevices,
  showSelectedDevices,
  showTagDevices,
  toggleShowSelectedTagDevice,
} from '../../../stores/reducers/tagsDevicesMap/AC';
import Dialog, { DialogConfig, DialogConfigSetter } from '../../Dialog';

import GoogleMap from 'react-google-maps/lib/components/GoogleMap';
import { ReactComponent as PlayIcon } from '../../../assets/svg/play_circle_cur.svg';
import C, { ICON_NAMES } from '../../../shared/constants';
import { selectIconContext } from '../../../shared/contexts/selectIcon.context';
import { getTagReadOnlyStatus } from '../../../shared/db/general-db';
import { getItemLabelNameValMap } from '../../../shared/db/tags-labels-selectors';
import { clientDb } from '../../../shared/firebase';
import * as tagsDb from '../../../shared/db/tags-db';
import { withSentry } from '../../../shared/hoc/withSentry';
import { useRedux } from '../../../states/redux-state';
import { UiActions, iReducersState } from '../../../stores/reducers';
import { selectDevices } from '../../../stores/reducers/devicesData/selector';
import DashboardBlock from '../../DashboardBlock';
import { ExtraInfo } from '../../elements/ExtraInfo/extra-info';
import ModalHeader from '../../menus/modal/modal-header';
import ClearModal from '../../ClearModal/ClearModal';
import './tag-details.scss';

import { getChannelsMore } from '../../../api/openApi';
import { ReactComponent as CloseIcon } from '../../../assets/svg/close_cur.svg';
import {getTagEditFieldVisibility, setDeviceColor} from '../../../shared/db/extra-info-db';
import { localStorage } from "../../../shared/storage";
import {
  openModal,
} from '../../../stores/reducers/videoCameras';
import { groupItemsIntoPages } from '../../../utils';
import CheckboxList from '../../core/CheckboxList';
import SearchInput from '../../core/SearchInput';
import MinimalTile from '../../general/MinimalTile';
import ContinueStreamModalForTag from '../devices/deviceStatuses/ForTag/ContinueStreamModalForTag/ContinueStreamModalForTag';
import DeviceStatusesForTag from '../devices/deviceStatuses/ForTag/DeviceStatusesForTag/DeviceStatusesForTag';
import ModalCamerasForTag from '../devices/deviceStatuses/ForTag/ModalCamerasForTag/ModalCamerasForTag';
import SelectChannelModal from '../devices/deviceStatuses/ForTag/SelectChannelModal/SelectChannelModal';
import { getDevicesFromTag } from "../reports/report-utils";
import PublicLinkModal from './PublicLinkModal';
import styles from './tag-details.module.scss';

const taggedDeviceIdsSelector = (
  tagId: string
): ((state: iFullStoreState) => ITaggedDeviceIds) =>
  pathOr({}, ['general', 'tags', tagId, 'instances', 'device']);
type ITaggedDeviceIds = { [deviceId: string]: true };

const mapStateToProps = (
  state: iFullStoreState,
  ownProps: IProps
): IPropsFromStore => ({
  authUser: state.auth.user,
  tags: state.general.tags,
  currentLabels: getItemLabelNameValMap(state, {
    type: ItemType.tag,
    itemId: ownProps.match.params.tagId,
  }),
  deviceFilterStr: state.ui.tagDeetsDeviceFilter,
});

type IProps = RouteComponentProps<{ tagId: string }>;

type IPropsFromStore = {
  authUser: UserAuth;
  tags: iList<iTag>;
  currentLabels: [string, string][];
  deviceFilterStr: string;
};
type IFullProps = IProps & IPropsFromStore & DispatchProp;

const confirmModalConfig: DialogConfig = {
  title: 'Alert Confirm Modal',
  body: 'Only one alert type can be attached to device. Confirm to continue',
  type: 'CONFIRM',
};

function TagDetailsPage(props: IFullProps) {
  const {
    tags,
    dispatch,
    currentLabels,
    deviceFilterStr,
    authUser,
  } = props;
  const { tagId } = props.match.params;
  const tag = tags[tagId];
  const taggedDeviceIdsList = useSelector(taggedDeviceIdsSelector(tagId));
  const person = useSelector<iFullStoreState, iPerson>(state => state.general.people?.[state.auth.user?.uid]);
  const allPeopleMap = useSelector((state: iFullStoreState) => state.general.people || {});
  const taggedDeviceIds = Object.keys(taggedDeviceIdsList);
  const taggedDeviceCount = taggedDeviceIds.length;
  const loginToken = localStorage.get('login-init-be-token');
  let isRenderedMap = useSelector<iFullStoreState, boolean>(
      (state) => state.gmap.isRendered
  );

  const [visibleSections, setVisibleSections] = useState({
    color: true,
    actions: true,
    enableAlerts: true
  });

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  // DEVICES
  const devicesDetails = useSelector(selectDevices);
  // devices data as objects, not react elements
  const allDevicesArray = useMemo(() => [...devicesDetails.values()], [devicesDetails]);
  const filteredDevices = useMemo(() => (
    allDevicesArray
      .filter(t => deviceFilterStr
        ? !!t.name && t.name.toLowerCase().indexOf(deviceFilterStr.toLowerCase()) !== -1
        : true)
  ), [allDevicesArray, deviceFilterStr]);
  const filteredDevicesIds = useMemo(() => filteredDevices.map(({ id }) => id), [filteredDevices]);

  const calculateIsAllSelected = () => {
    // we use `some` and reverted logic, as `every` returns true for empty array
    const doesOneNotSelectedExist = filteredDevicesIds.some((id) => !taggedDeviceIds.includes(id));
    // if no [one element not selected] => all items are selected
    return !doesOneNotSelectedExist;
  };

  const [isAllDeviceSelected, setIsAllDeviceSelected] = useState(() => {
    if (calculateIsAllSelected()) {
      return true;
    }
    if (taggedDeviceIds.length === 0) {
      return false;
    }

    return false;
  });

  useEffect(() => {
    const isAllSelected = calculateIsAllSelected();
    (isAllSelected) && setIsAllDeviceSelected(true);
  }, [taggedDeviceIds.length, filteredDevicesIds.length]);

  const [isSvg, setIsSvg] = useState(false);
  const [svgIcon, setSvgIcon] = useState<any>(null);

  const mapRef = useSelector<
    iFullStoreState,
    React.RefObject<GoogleMap> | null
  >((state) => state.gmap.mapRef());

  useEffect(() => {
    const saveIcon = async () =>
      await tagsdb.update(authUser)(tagId, { svgIcon });

    if (svgIcon !== null) {
      saveIcon();
    } else if (!isSvg) setSvgIcon(null);
  }, [svgIcon, isSvg]);

  const devicesMarker = useRedux((s) => s.devicesData.devicesLastPing)
    .valueSeq()
    .toArray()
    .filter((it) => it !== null);

  const { selectIcon } = React.useContext(selectIconContext);

  const dialogRef = React.useRef<DialogConfigSetter>();
  const dialog = dialogRef.current;
  const setupDialog = (callBack: () => DialogConfigSetter) =>
    (dialogRef.current = callBack());

  const showDevices = () => {
    dispatch(showTagDevices(tagId));
  };

  const removeAllTags = () => {
    dispatch(hideAllTags());
  };

  React.useEffect(() => {
    removeAllTags();
    showDevices();

    return () => {
      removeAllTags();
    };
  }, [tagId]);

  const sortByIds = (arrayToSort, orderArray) => orderArray
      .map(id => arrayToSort
          .find(item => item.device === id)
      );

  const publicViewArr = sortByIds(devicesMarker, taggedDeviceIds)
      .filter((device) => device !== undefined);

  const IS_PUBLIC_VIEW = window.location.href.includes('public-view');

  React.useEffect(() => {
    if (IS_PUBLIC_VIEW && isRenderedMap) {
        if (publicViewArr.length) {
          dispatch(GmapActions.RECENTER_MAP_TO_DEVICE(publicViewArr[0]?.device, true));
          dispatch(GmapActions.RECENTER_MAP(publicViewArr[0]?.coordinates?.location, true));
        } else {
          mapRef && mapRef.current.context[MAP].setZoom(4);
        }
    }
  }, [IS_PUBLIC_VIEW, isRenderedMap]);

  const history = useHistory();

  const fetchTagEditFiledsVisbility = async () => {
    try {
      const settings = await getTagEditFieldVisibility();
      setVisibleSections({
        color: settings?.color,
        actions: settings?.actions,
        enableAlerts: settings?.enable_alerts
      })
    }
    catch(error) {
      console.error('Error when fetch tag edit fields visibility');
    }
  }

  useEffect(() => {
    if (IS_PUBLIC_VIEW || !authUser?.uid) return;
    (async () => {
      const readOnlyTag = await getTagReadOnlyStatus(authUser.uid, tagId);
      if (readOnlyTag) {
        await dialog?.({
          title: 'Permission error',
          body: 'This tag is read only',
          type: 'NOTIFICATION',
          afterClose: () => history.goBack(),
        });
      }
    })();
  });

  useEffect(() => {
    fetchTagEditFiledsVisbility();
    findSvg(tag.details.icon);
  }, []);

  const changeImage = async () => {
    try {
      let selectedIcon = await selectIcon?.();
      let icon: iIcon

      if (!selectedIcon || !(typeof selectedIcon == 'object')) {
        return;
      }
      if ('icon' in selectedIcon) {
        icon = {
          type: IconTypes.FaIcon,
          fa: selectedIcon,
        };
      } else if ('name' in selectedIcon && ICON_NAMES[selectedIcon.name]) {
        icon = {
          type: IconTypes.SvgIcon,
          svgIconName: selectedIcon.name as string,
        };
      } else {
        icon = {
          type: IconTypes.UserSvgIcon,
          url: await generaldb.saveIcon(selectedIcon as File),
        };
      }

      findSvg(icon);

      await tagsdb.update(authUser)(tagId, { icon });
    } catch (e) {
      console.log('change image error', e);
      dialog?.({
        title: 'Permission error',
        body: "You don't have permission to edit tags",
        type: 'NOTIFICATION',
      });
    }
  };

  const findSvg = async (icon) => {
    const url = (icon as any)?.url;
    if (!url) {
      setIsSvg(false);
      return;
    }

    try {
      const res = await fetch(url);
      const index = res.headers.get('content-type').indexOf('svg');
      setIsSvg(index === -1 ? false : true);
    } catch (err) {
      console.warn('findSvg fetch failed:', err);
      setIsSvg(false);
    }
  };

  const setToAlert = (on: boolean) => async (_) => {
    // prevent changing if already tagging something
    // if this changes we will need to handle case where tag is shared on device or is on a person etc

    if (on && vals(tag.instances).length) {
      dialog?.({
        title: 'Ineligible',
        body: 'This tag is assigned to a device or person and is ineligible for conversion into an alert type tag.',
        type: 'NOTIFICATION',
      });
      return;
    }

    if (on && !(await dialog?.(confirmModalConfig))) return;

    try {
      tagsdb.update(authUser)(tagId, {
        isAlertType: on,
        eventValues: null,
      });
    } catch (e) {
      console.log('set to alert error', e);
      dialog?.({
        title: 'Permission error',
        body: "You don't have permission to edit tags",
        type: 'NOTIFICATION',
      });
    }
  };
  const tagDetails = tag.details;
  const [selectedColor, setSelectedColor] = useState(tagDetails.color ?? "");
  const isTagVisibleInLegend = tagDetails.showInLegend ?? false;
  const getPickerColor = (value: string) => /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value) ? value : '#ff7c02';
  const colorInputRef = useRef<HTMLInputElement>(null);

  const handleColorClick = async (hex: string) => {
      setSelectedColor(hex);
  };

  const handleToggleShowInLegend = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      await tagsdb.update(authUser)(tagId, { showInLegend: event.target.checked });
    } catch (e) {
      console.log('show in legend update error', e);
      dialog?.({
        title: 'Permission error',
        body: "You don't have permission to edit tags",
        type: 'NOTIFICATION',
      });
    }
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
      if (isFirstRender.current) {
          isFirstRender.current = false;
          return;
      }

      tagsdb.update(authUser)(tagId, { color: selectedColor });
      changeColorAprove().then(() => {});
  }, [selectedColor]);

  async function changeColorAprove() {
      if (selectedColor !== "" && selectedColor !== "none") {
          try {
              const tagDevices = await getDevicesFromTag(tagId);
              await setDeviceColor(authUser, tagDevices, selectedColor);
          } catch {
              dialog?.({
                  title: "Permission error",
                  body: "You don't have permission to edit tags",
                  type: "NOTIFICATION",
              });
          }
      }
  }

  const updateName = async (name: string) => {
    try {
      await tagsdb.update(authUser)(tagId, { name });
    } catch (e) {
      console.log('e', e);
      dialog?.({
        title: 'Permission error',
        body: "You don't have permission to edit tags",
        type: 'NOTIFICATION',
      });
    }
  };

  const toggleSelectedDevice = async (deviceId: string) => {
    const isDeviceAdded = !taggedDeviceIds.includes(deviceId);

    if (isDeviceAdded) {
        if(selectedColor !== "" && selectedColor !== "none") {
            await setDeviceColor(authUser, deviceId, tag.details.color);
        }
    }

    if (!tag.details.isAlertType) {
      // not items are selected -> change this state
      setIsAllDeviceSelected(false);

      try {
        await toggleDeviceTag(deviceId);
        dispatch(toggleShowSelectedTagDevice(tagId, deviceId));
      } catch (e) {
        dialog?.({
          title: 'Permission error',
          body: "You don't have permission to edit tags",
          type: 'NOTIFICATION',
        });
      }
    }
  };

  const deviceQueueRef = useRef<Promise<any>>(Promise.resolve());
  const enqueueDeviceRequest = (task: () => Promise<any>) => {
    deviceQueueRef.current = deviceQueueRef.current.then(task).catch((e) => {
      console.error("Queue error", e);
    });
    return deviceQueueRef.current;
  };

  const hasOtherAclSources = (aclEntry: Record<string, any> | undefined, currentTagId: string): boolean =>
    Object.keys(aclEntry || {}).some((sourceId) => sourceId !== 'readOnly' && sourceId !== currentTagId);

  const hasCurrentAclSource = (aclEntry: Record<string, any> | undefined, currentTagId: string): boolean =>
    Object.keys(aclEntry || {}).some((sourceId) => sourceId === currentTagId);

  const toggleDeviceTag = async (deviceId: string) => {
    await enqueueDeviceRequest(async () => {
      try {
        const currentTagIdsForDevice = Object.keys(tags)
          .filter((currentTagId) => path(['instances', 'device', deviceId], tags[currentTagId]));

        const shouldRemoveFromCurrentTag = !!path(['instances', 'device', deviceId], tag);
        const nextTagIds = shouldRemoveFromCurrentTag
          ? currentTagIdsForDevice.filter((currentTagId) => currentTagId !== tagId)
          : Array.from(new Set([...currentTagIdsForDevice, tagId]));

        const update: Record<string, any> = {};
        const peopleAllowedSee =
          (
            await clientDb()
              .child('tags')
              .child(tagId)
              .child('instances')
              .child('allowed-see')
              .child('person')
              .once('value')
          ).val() || {};

        if (shouldRemoveFromCurrentTag) {

          for (const personId of Object.keys(peopleAllowedSee)) {
            const value = (
              await clientDb()
                .child(`acl/items-allowed/${personId}/device/${deviceId}`)
                .once('value')
            ).val();

            if (!hasCurrentAclSource(value, tagId)) {
              continue;
            }

            const tagPathToDelete = hasOtherAclSources(value, tagId)
              ? `/acl/items-allowed/${personId}/device/${deviceId}/${tagId}`
              : `/acl/items-allowed/${personId}/device/${deviceId}`;

            update[tagPathToDelete] = null;
          }
        }

        await tagsdb.setItemTags(authUser)(
          false,
          ItemType.device,
          deviceId,
          nextTagIds,
          tagId
        );

        const taggedDevices =
          (
            await clientDb()
              .child('tags')
              .child(tagId)
              .child('instances')
              .child('device')
              .once('value')
          ).val() || {};

        for (const personId of Object.keys(peopleAllowedSee)) {
          for (const devId of Object.keys(taggedDevices)) {
            update[`/acl/items-allowed/${personId}/device/${devId}/${tagId}`] = 'tag';
            update[`/acl/items-allowed/${personId}/device/${devId}/readOnly`] = true;
          }
        }

        await clientDb().update(makeAudit(authUser, update));
      } catch (e) {
        console.error("toggle device tag error", e);
        dialog?.({
          title: "Permission error",
          body: "You don't have permission to edit tags",
          type: "NOTIFICATION",
        });
      }
    });

    return true;
  };

  async function handleSelectAllClick() {
    setIsAllDeviceSelected((prev) => !prev);

    const toggleValue = !isAllDeviceSelected;
    tagsdb
      .toggleDevicesForTag(filteredDevicesIds, tagId, toggleValue)
      .then(() => {
        if (isAllDeviceSelected) {
          dispatch(hideSelectedDevices(filteredDevicesIds));
        } else {
          let markerBounds = new google.maps.LatLngBounds();

          devicesMarker.forEach((marker) => {
            markerBounds.extend(
              new google.maps.LatLng(
                marker.coordinates.location.lat,
                marker.coordinates.location.lng
              )
            );
          });

          mapRef.current.fitBounds(markerBounds);
          dispatch(showSelectedDevices(filteredDevicesIds));
        }
      })
      .catch((e) => {
        console.error('toggle device tag error', e);
        dialog?.({
          title: 'Permission error',
          body: "You don't have permission to edit tags",
          type: 'NOTIFICATION',
        });
      });
    await changeColorAprove();
  }

  const handleDeviceSearch = (search: string) => {
    // reset select all on search
    setIsAllDeviceSelected(false);

    return dispatch(UiActions.SET_TAG_DEETS_DEVICE_FILTER(search));
  };

  const naturalSort = (a, b, order = "asc") => {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

    const cleanedA = a.name?.trim().replace(/\s+/g, " ") || "";
    const cleanedB = b.name?.trim().replace(/\s+/g, " ") || "";

    const comparison = collator.compare(cleanedA, cleanedB);

    return order === "asc" ? comparison : -comparison;
  };

  const compareByNameAscending = (a, b) => naturalSort(a, b, "asc");

  const compareByLastNameAscending = (a, b) => {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
    const getNames = (obj) => {
      const parts = obj.name.trim().split(' ');
      return parts.length === 2 ? { last: parts[0], first: parts[1] } : { last: obj.name, first: '' };
    };
    const aNames = getNames(a);
    const bNames = getNames(b);
    const lastComp = collator.compare(aNames.last, bNames.last);
    if (lastComp !== 0) return lastComp;
    return collator.compare(aNames.first, bNames.first);
  };

  const deviceSections = useMemo(() => {
    const devicesInSection = 1;
    const allDevices = filteredDevices
      .map((device) => ({
        id: device.id,
        name: device.name,
        onChange: () => toggleSelectedDevice(device.id),
      }))
      .sort(compareByNameAscending);

    return groupItemsIntoPages(allDevices, devicesInSection)
      .map((v, i) => ({id: `device-section-${i}`, value: v}));
  }, [filteredDevices, toggleSelectedDevice]);

  const AllSerialNumbersWithExtraInfo = Array.from(devicesDetails).map((el: any) => {
    const serialNumber = el[0];
    const extraInfo = el?.[1]?.['extra-info']?.[0];
    if (el?.[1]?.isCamera) {
      return { [serialNumber]: extraInfo }
    }
  });

  const objectWithDeviceIdAndSerial = Object.assign({}, ...AllSerialNumbersWithExtraInfo);

  const objectWithDeviceIdAndSerialThatTagHas = {};
  taggedDeviceIds.forEach((key) => {
    if (objectWithDeviceIdAndSerial.hasOwnProperty(key)) {
      objectWithDeviceIdAndSerialThatTagHas[key] = objectWithDeviceIdAndSerial[key];
    }
  });

  const arrayOfSerialsThatTagHas = Object.values(objectWithDeviceIdAndSerialThatTagHas);

  const filterDevicesInfoOnlyThatTagHas = (arr, idArray) => {
    const result = arr.filter(item => {
      const extraInfo = item[1]["extra-info"];
      return extraInfo && idArray.includes(extraInfo["0"]);
    });

    return result;
  }

  const arrayOfAllDevicesInfo = Array.from(devicesDetails);

  const deviceData = filterDevicesInfoOnlyThatTagHas(arrayOfAllDevicesInfo, arrayOfSerialsThatTagHas);

  // only fetch if tag has devices and at least one tagged device is a camera
  const shouldFetchChannelLinks = useMemo(() => {
    if (!taggedDeviceIds || taggedDeviceIds.length === 0) return false;

    try {
      for (const id of taggedDeviceIds) {
        const dev = (devicesDetails && typeof (devicesDetails as any).get === 'function')
          ? (devicesDetails as any).get(id)
          : (devicesDetails as any)[id];

        if (dev && dev.isCamera) return true;
      }

      return false;
    } catch (e) {
      console.error('shouldFetchChannelLinks error', e.message);
      return false;
    }
  }, [taggedDeviceIds.join(','), devicesDetails]);

  const { openLiveViewPlayer, openLiveViewModal, openContinueLiveStreamingModal }: any = useSelector(
    (state: iReducersState) => state.videoCameras.modals
  );

  const liveViewClick = async () => {
    dispatch(openModal({ key: 'openLiveViewModal', value: true }));
  }

  const REMINDER_INTERVAL: number = 60000;

  const [reminderIntervalTime, setReminderIntervalTime] = useState<number>(REMINDER_INTERVAL);
  const [triggerCloseModal, setTriggerCloseModal] = useState(false);
  const [selectedChannels, setSelectedChannels] = useState({ channel_id: null, name: null });
  const [toCloseModalNow, setToCloseModalNow] = useState(false);
  const [channelLinksForCameras, setChannelLinksForCameras] = useState([]);

  const getChannelLinksForCameras = async () => {
    try {
      const res = await getChannelsMore({ firebaseTagId: tagId, orgKey: loginToken['clientId'] });
      setChannelLinksForCameras(res.data?.streams);
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    if (openContinueLiveStreamingModal === false && !IS_PUBLIC_VIEW && shouldFetchChannelLinks) {
      getChannelLinksForCameras();
    }
  }, [selectedChannels, openContinueLiveStreamingModal, shouldFetchChannelLinks])

  const [isPublicLinkModalOpen, setIsPublicLinkModalOpen] = useState(false);

  const findDeviceBySerial = (serial: string) => {
    if(!serial){
      return null;
    }

    for (const device of arrayOfAllDevicesInfo) {
      const extraInfo = device[1]['extra-info'];
      if(!extraInfo){
        return null;
      }

      let foundSerial;

      if (Array.isArray(extraInfo) && extraInfo.length === 1 && typeof extraInfo[0] === 'string') {
        foundSerial = extraInfo[0];
      }
      else if (typeof extraInfo === 'object' && extraInfo !== null && extraInfo.hasOwnProperty('0')) {
        foundSerial = extraInfo['0'];
      }

      if(foundSerial === serial){
        return device[1].name;
      }
    }
  }

  const [isTagNameEditing, setIsTagNameEditing] = useState(false);
  const [tagName, setTagName] = useState(tagDetails.name);
  const saveName = () => {
    updateName(tagName);
    setIsTagNameEditing(false);
  };

  const cancelNameEditing = () => {
    setTagName(tagDetails.name);
    setIsTagNameEditing(false);
  };

  const hasSerialsToView = arrayOfSerialsThatTagHas.length > 0;
  const areAlertsEnabled = tagDetails.isAlertType;

  // PEOPLE
  const allowedPeopleInitial: Record<string, any> =
    (pathOr({}, ['instances', 'allowed-see', 'person'], tag) as Record<string, any>) || {};

  const [allowedPeopleLocal, setAllowedPeopleLocal] = useState<Record<string, any>>(allowedPeopleInitial);
  useEffect(() => {
    setAllowedPeopleLocal((pathOr({}, ['instances', 'allowed-see', 'person'], tag) as Record<string, any>) || {});
  }, [tag]);

  const [personFilterStr, setPersonFilterStr] = useState('');
  const allPeopleArray: Array<{ id: string; name: string }> = useMemo(() => {
    return Object.entries(allPeopleMap || {}).map(([id, p]: any) => {
      let rawName = (p?.name || p?.displayName || p?.email || id || '').toString();
      const nameParts = rawName.trim().split(' ');
      let displayName = rawName;
      if (nameParts.length === 2) {
        displayName = `${nameParts[1]}, ${nameParts[0]}`;
      }
      return {
        id,
        name: displayName,
        _rawName: rawName // for sorting fallback
      };
    });
  }, [allPeopleMap]);

  const filteredPeople = useMemo(() => {
    const q = personFilterStr.trim().toLowerCase();
    return allPeopleArray
      .filter(p => p.id)
      .filter(p => (q ? (p.name || '').toLowerCase().includes(q) : true));
  }, [allPeopleArray, personFilterStr]);
  const filteredPeopleIds = useMemo(() => filteredPeople.map(p => p.id), [filteredPeople]);

  const calculateIsAllPeopleSelected = () => {
    const oneNotSelected = filteredPeopleIds.some((id) => !Object.prototype.hasOwnProperty.call(allowedPeopleLocal, id));
    return !oneNotSelected && filteredPeopleIds.length > 0;
  };
  const [isAllPeopleSelected, setIsAllPeopleSelected] = useState<boolean>(calculateIsAllPeopleSelected());
  useEffect(() => {
    setIsAllPeopleSelected(calculateIsAllPeopleSelected());
  }, [filteredPeopleIds.join(','), Object.keys(allowedPeopleLocal).join(',')]);

  const [pendingPeople, setPendingPeople] = useState<Record<string, boolean>>({});
  const [bulkPending, setBulkPending] = useState(false);
  const peopleQueueRef = useRef<Promise<any>>(Promise.resolve());
  const enqueuePersonRequest = (task: () => Promise<any>) => {
    peopleQueueRef.current = peopleQueueRef.current
      .then(task)
      .catch((e) => console.error('people queue error', e));
    return peopleQueueRef.current;
  };

  const UPDATE_BATCH_SIZE = 200;
  const ACL_FETCH_CONCURRENCY = 8;
  const sleep = (ms = 0) => new Promise(res => setTimeout(res, ms));
  const getTaggedDevicesOnce = React.useCallback(async () => {
    const snap = await clientDb()
      .child('tags')
      .child(tagId)
      .child('instances')
      .child('device')
      .once('value');
    return (snap.val() || {}) as Record<string, true>;
  }, [tagId]);

  const handlePersonSearch = (val: string) => {
    setIsAllPeopleSelected(false);
    setPersonFilterStr(val);
  };

  const toggleSelectedPerson = async (personId: string) => {
    if (pendingPeople[personId] || bulkPending) return;

    setPendingPeople(prev => ({ ...prev, [personId]: true }));

    const wasAllowed = !!allowedPeopleLocal[personId];

    // оптимістика
    setAllowedPeopleLocal(prev => {
      const next = { ...prev };
      if (wasAllowed) delete next[personId];
      else next[personId] = true as any;
      return next;
    });

    await enqueuePersonRequest(async () => {
      try {
        const taggedDevices = await getTaggedDevicesOnce();

        let batch: Record<string, any> = {};
        let count = 0;

        if (wasAllowed) {
          batch[`/tags/${tagId}/instances/allowed-see/person/${personId}`] = null; count++;
          batch[`/tags/${tagId}/instances/allowed-see/readOnly/${personId}`] = null; count++;

          const personDevicesSnap = await clientDb()
            .child(`acl/items-allowed/${personId}/device`)
            .once('value');
          const personDevices: Record<string, any> = personDevicesSnap.val() || {};

          for (const deviceId of Object.keys(taggedDevices)) {
            const value = personDevices[deviceId];

            if (!hasCurrentAclSource(value, tagId)) {
              continue;
            }

            const pathToDelete = hasOtherAclSources(value, tagId)
              ? `/acl/items-allowed/${personId}/device/${deviceId}/${tagId}`
              : `/acl/items-allowed/${personId}/device/${deviceId}`;
            batch[pathToDelete] = null; count++;

            if (count >= UPDATE_BATCH_SIZE) {
              await clientDb().update(makeAudit(authUser, batch));
              batch = {}; count = 0;
              await sleep(0);
            }
          }
        } else {
          batch[`/tags/${tagId}/instances/allowed-see/person/${personId}`] = true; count++;
          batch[`/tags/${tagId}/instances/allowed-see/readOnly/${personId}`] = true; count++;

          for (const deviceId of Object.keys(taggedDevices)) {
            batch[`/acl/items-allowed/${personId}/device/${deviceId}/${tagId}`] = 'tag'; count++;
            batch[`/acl/items-allowed/${personId}/device/${deviceId}/readOnly`] = true; count++;
            if (count >= UPDATE_BATCH_SIZE) {
              await clientDb().update(makeAudit(authUser, batch));
              batch = {}; count = 0;
              await sleep(0);
            }
          }
        }

        if (count) await clientDb().update(makeAudit(authUser, batch));
      } catch (e) {
        console.error('toggle person allowed-see error', e);
        setAllowedPeopleLocal(prev => {
          const next = { ...prev };
          if (wasAllowed) next[personId] = true as any;
          else delete next[personId];
          return next;
        });
        dialog?.({
          title: 'Permission error',
          body: "You don't have permission to edit tags",
          type: 'NOTIFICATION',
        });
      } finally {
        setPendingPeople(prev => {
          const { [personId]: _omit, ...rest } = prev;
          return rest;
        });
      }
    });
  };

  const handleSelectAllPeople = async () => {
    if (bulkPending) return;
    setBulkPending(true);

    try {
      const toggleTo = !isAllPeopleSelected;
      setIsAllPeopleSelected(toggleTo);

      setAllowedPeopleLocal(prev => {
        const next = { ...prev };
        if (toggleTo) {
          for (const personId of filteredPeopleIds) next[personId] = true as any;
        } else {
          for (const personId of filteredPeopleIds) delete next[personId];
        }
        return next;
      });

      await enqueuePersonRequest(async () => {
        const taggedDevices = await getTaggedDevicesOnce();

        let batch: Record<string, any> = {};
        let count = 0;

        if (toggleTo) {
          for (const personId of filteredPeopleIds) {
            batch[`/tags/${tagId}/instances/allowed-see/person/${personId}`] = true; count++;
            batch[`/tags/${tagId}/instances/allowed-see/readOnly/${personId}`] = true; count++;

            for (const deviceId of Object.keys(taggedDevices)) {
              batch[`/acl/items-allowed/${personId}/device/${deviceId}/${tagId}`] = 'tag'; count++;
              batch[`/acl/items-allowed/${personId}/device/${deviceId}/readOnly`] = true; count++;
              if (count >= UPDATE_BATCH_SIZE) {
                await clientDb().update(makeAudit(authUser, batch));
                batch = {}; count = 0;
                await sleep(0);
              }
            }
            if (count >= UPDATE_BATCH_SIZE) {
              await clientDb().update(makeAudit(authUser, batch));
              batch = {}; count = 0;
              await sleep(0);
            }
          }
          if (count) await clientDb().update(makeAudit(authUser, batch));
        } else {
          for (const personId of filteredPeopleIds) {
            batch[`/tags/${tagId}/instances/allowed-see/person/${personId}`] = null; count++;
            batch[`/tags/${tagId}/instances/allowed-see/readOnly/${personId}`] = null; count++;

            if (count >= UPDATE_BATCH_SIZE) {
              await clientDb().update(makeAudit(authUser, batch));
              batch = {}; count = 0;
              await sleep(0);
            }
          }
          if (count) {
            await clientDb().update(makeAudit(authUser, batch));
            batch = {}; count = 0;
            await sleep(0);
          }

          const mapWithConcurrency = async <T, R>(
            items: T[], limit: number,
            iter: (item: T, idx: number) => Promise<R>
          ): Promise<R[]> => {
            const res: R[] = new Array(items.length);
            let i = 0;
            const workers = new Array(Math.min(limit, items.length)).fill(0).map(async () => {
              while (i < items.length) {
                const idx = i++;
                res[idx] = await iter(items[idx], idx);
                await sleep(0);
              }
            });
            await Promise.all(workers);
            return res;
          };

          const aclSnaps = await mapWithConcurrency(
            filteredPeopleIds,
            ACL_FETCH_CONCURRENCY,
            (pid) => clientDb().child(`acl/items-allowed/${pid}/device`).once('value')
          );

          for (let idx = 0; idx < filteredPeopleIds.length; idx++) {
            const personId = filteredPeopleIds[idx];
            const personDevices: Record<string, any> = aclSnaps[idx].val() || {};

            for (const deviceId of Object.keys(taggedDevices)) {
              const value = personDevices[deviceId];

              if (!hasCurrentAclSource(value, tagId)) {
                continue;
              }

              const pathToDelete = hasOtherAclSources(value, tagId)
                ? `/acl/items-allowed/${personId}/device/${deviceId}/${tagId}`
                : `/acl/items-allowed/${personId}/device/${deviceId}`;
              batch[pathToDelete] = null; count++;

              if (count >= UPDATE_BATCH_SIZE) {
                await clientDb().update(makeAudit(authUser, batch));
                batch = {}; count = 0;
                await sleep(0);
              }
            }
          }
          if (count) await clientDb().update(makeAudit(authUser, batch));
        }
      });
    } catch (e) {
      console.error('select all people error', e);
      dialog?.({
        title: 'Permission error',
        body: "You don't have permission to edit tags",
        type: 'NOTIFICATION',
      });
    } finally {
      setBulkPending(false);
    }
  };

  const peopleSections = useMemo(() => {
    const peopleInSection = 1;
    const items = filteredPeople
      .map((p) => ({
        id: p.id,
        name: p.name,
        onChange: () => {
          if (!pendingPeople[p.id] && !bulkPending) {
            toggleSelectedPerson(p.id);
          }
        },
      }))
      .sort(compareByLastNameAscending);

    return groupItemsIntoPages(items, peopleInSection).map((v, i) => ({
      id: `people-section-${i}`,
      value: v,
    }));
  }, [filteredPeople, pendingPeople, bulkPending, compareByNameAscending]);

  const selectedPeopleIds = Object.keys(allowedPeopleLocal);
  const selectedPeopleCount = selectedPeopleIds.length;

  return (
    <>
      <DashboardBlock>
        <ModalHeader
          title={
             <div className={classNames(styles.tagNameSection, { [styles.editMode]: isTagNameEditing })}>
              <div className={styles.tagNameSectionLabel}>
                <button
                  type='button'
                  onClick={saveName}
                  className={styles.saveChangesButton}
                >
                  Save Changes
                </button>
              </div>

              <div className={styles.tagNameInput}>
                <input
                  value={tagName}
                  onChange={({ target: { value } }) => setTagName(value)}
                  onFocus={() => setIsTagNameEditing(true)}
                />
                <button
                  onClick={cancelNameEditing}
                  className={styles.closeButton}
                >
                  <CloseIcon className={styles.closeIcon} />
                </button>
              </div>
            </div>
          }
          style={{ marginBottom: 16 }}
        />

        {/* TAG'S NAME */}
        {/* <div className={classNames(styles.tagNameSection, { [styles.editMode]: isTagNameEditing })}>
          <div className={styles.tagNameSectionLabel}>
            <p className={styles.sectionLabel}>Tag Name</p>
            <button
              type='button'
              onClick={saveName}
              className={styles.saveChangesButton}
            >
              Save Changes
            </button>
          </div>

          <div className={styles.tagNameInput}>
            <input
              value={tagName}
              onChange={({ target: { value } }) => setTagName(value)}
              onFocus={() => setIsTagNameEditing(true)}
            />
            <button
              onClick={cancelNameEditing}
              className={styles.closeButton}
            >
              <CloseIcon className={styles.closeIcon} />
            </button>
          </div>
        </div> */}

        {/* DEVICES */}
        {/* selected count */}
        <div className={styles.selectedDeviceContainer}>
          <p>Select Vehicles:</p>
          <p className={styles.selectedCount}>{taggedDeviceCount} Items Selected</p>
        </div>

        <SearchInput
          value={deviceFilterStr}
          onChange={handleDeviceSearch}
          placeholder='Filter Vehicles'
          className={styles.searchInput}
        />

        <CheckboxList
          sections={deviceSections}
          selected={taggedDeviceIds}
          changeAllItems={handleSelectAllClick}
          isAllSelected={isAllDeviceSelected}
          containerClassName={classNames(styles.checkboxesList, styles.vehiclesList)}
        />

        {/* USERS */}
        <div className={styles.selectedDeviceContainer} style={{ marginTop: 24 }}>
          <p>Select Users (Allowed access):</p>
          <p className={styles.selectedCount}>{selectedPeopleCount} Selected</p>
        </div>

        <SearchInput
          value={personFilterStr}
          onChange={handlePersonSearch}
          placeholder='Filter Users'
          className={styles.searchInput}
        />

        <CheckboxList
          sections={peopleSections}
          selected={selectedPeopleIds}
          changeAllItems={handleSelectAllPeople}
          isAllSelected={isAllPeopleSelected}
          containerClassName={styles.checkboxesList}
        />

        {/* TAG'S COLOR */}
        {visibleSections.color &&
          <div className={styles.tagColorSection}>
            <p className={styles.sectionLabel}>Tag Color</p>
            <div className={styles.tagColorControls}>
              <div className={styles.colorPickerRow}>
                <button
                  type="button"
                  onClick={() => colorInputRef.current?.click()}
                  className={styles.colorPickerTrigger}
                  aria-label="Open tag color picker"
                >
                  <span
                    className={classNames(styles.colorPickerSwatch, {
                      [styles.colorPickerSwatchWithColor]: !!selectedColor,
                    })}
                    style={selectedColor ? { backgroundColor: selectedColor } : undefined}
                  />
                </button>
                <input
                  ref={colorInputRef}
                  type="color"
                  value={getPickerColor(selectedColor)}
                  onChange={(event) => handleColorClick(event.target.value)}
                  className={styles.colorPickerNativeInput}
                  aria-label="Choose tag color"
                />
                <span className={styles.colorHexValue}>{(selectedColor || '').toUpperCase() || 'No color selected'}</span>
                <button
                  type="button"
                  onClick={() => handleColorClick('')}
                  className={styles.clearColorButton}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        }

        {visibleSections.color && tagId !== ALL_DEVICES_TAG && (
          <div className={styles.legendSection}>
            <label className={styles.legendVisibilityRow}>
              <span className={styles.sectionLabel}>Show in Legend:</span>
              <input
                type="checkbox"
                checked={isTagVisibleInLegend}
                onChange={handleToggleShowInLegend}
              />
            </label>
          </div>
        )}

        {/* Delete tag */}
        <div className={styles.deleteTagSection}>
          <button
            type='button'
            onClick={() => setDeleteModalOpen(true)}
            className={styles.deleteButton}
          >
            <DeleteIcon />
            Delete
          </button>

          {/* Delete Confirmation Modal */}
          <ClearModal
            open={isDeleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
             onConfirm={() => {
              tagsDb.deleteTags(authUser)(tag);
              setDeleteModalOpen(false);
              history.push('/tags');
            }}
            title="Delete Tag"
            bodyText="Are you sure you want to delete this tag? This action cannot be undone."
          />
        </div>

        {visibleSections.actions &&
          <div className={styles.actionsSection}>
            <p className={styles.sectionLabel}>Actions</p>

            <div className={styles.actionsList}>
              <button
                type='button'
                className={styles.actionItem}
                title={hasSerialsToView ? 'Live View' : 'No camera devices selected for live View'}
                onClick={hasSerialsToView ? liveViewClick : () => {}}
                disabled={!hasSerialsToView}
              >
                <PlayIcon className={styles.actionItemIcon} />
                <span>View</span>
              </button>

              <button
                onClick={() => setIsPublicLinkModalOpen(true)}
                className={styles.actionItem}
              >
                <PublicIcon className={styles.actionItemIcon} />
                <span>Public</span>
              </button>

              <button
                onClick={setToAlert(!areAlertsEnabled)}
                className={classNames(styles.actionItem, {[styles.actionOn]: areAlertsEnabled})}
              >
                {
                  areAlertsEnabled
                    ? <NotificationsOnIcon className={styles.actionItemIcon} />
                    : <NotificationsOffIcon className={styles.actionItemIcon} />
                }
                <span>{areAlertsEnabled ? 'Alerts Enabled' : 'Alerts Disabled'}</span>
              </button>
            </div>
          </div>
        }

        <div style={{ position: 'relative', marginTop: 16 }}>
          {visibleSections.enableAlerts &&
            <div
              style={{
                ...(tagDetails.isAlertType ? { display: 'none' } : noAlertsStyle),
              }}
            >
              <MinimalTile
                style={{
                  border: `1px solid ${C.primaryColor}`,
                  backgroundColor: '#fff',
                  margin: 10,
                }}
              >
                Enable Alerts to Edit
              </MinimalTile>
            </div>
          }

        {/*  <ExtraInfo */}
       {/*     editUrl={`/${ItemType.tag}/${tagDetails.id}/add/extra-info`} */}
       {/*     labels={currentLabels} */}
       {/*     itemType={ItemType.tag} */}
       {/*     itemId={tagDetails.id} */}
       {/*     title={process.env.REACT_APP_EXTRA_INFO_DEVICE_MENU_ITEM_NAME || 'Extra Info'} */}
       {/*   /> */}

          <div style={{ marginTop: 10, textAlign: 'center' }}>
          </div>
        </div>
      </DashboardBlock>
      <Dialog setupConfig={setupDialog} />
      <ModalCamerasForTag toCloseModalNow={toCloseModalNow} setToCloseModalNow={setToCloseModalNow}>
        {
          openLiveViewModal && (
            <SelectChannelModal
              setSelectedChannels={setSelectedChannels}
              selectedChannels={selectedChannels}
            />)
        }
        <div className={styles.gridCameras}>
          {openLiveViewPlayer &&
          deviceData.map(([firebaseDeviceId, deviceInfo], index) => {
            const channelLinks = channelLinksForCameras[index];
            const deviceName = findDeviceBySerial(channelLinks?.uniqueId);

            return (
              <DeviceStatusesForTag
                deviceName={deviceName}
                device={deviceInfo}
                arrayOfSerialsThatTagHas={arrayOfSerialsThatTagHas}
                index={index}
                channelLinksForCameras={channelLinks}
                uniqueId={channelLinks?.uniqueId}
                channelProp={selectedChannels.channel_id}
                triggerCloseModal={triggerCloseModal}
                reminderIntervalTime={reminderIntervalTime}
              />)
          })
        }
        </div>
      </ModalCamerasForTag>

      {(isPublicLinkModalOpen) && (
        <PublicLinkModal
          setIsPublicLinkModalOpen={setIsPublicLinkModalOpen}
          tagId={tagId}
        />
      )}

      {(!person?.suppressContinueStreamModal && openContinueLiveStreamingModal) &&
        (<ContinueStreamModalForTag
          closeContinueLiveStreamingModal={() => dispatch(openModal({ key: "openContinueLiveStreamingModal", value: false }))}
          setReminderIntervalTime={setReminderIntervalTime}
          setTriggerCloseModal={setTriggerCloseModal}
        />)
      }
    </>
  );
}

export default withSentry(connect(mapStateToProps)(TagDetailsPage));

const noAlertsStyle: css = {
  backgroundColor: color('#333').fade(0.7),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};